import { Text, AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, HStack } from '@chakra-ui/react';
import { useCallback, useRef } from 'react';

interface IAlertUploadFileProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

function AlertUploadFile({ isOpen, onClose, onConfirm }: IAlertUploadFileProps): JSX.Element {
  const cancelRef = useRef<HTMLButtonElement>(null);
  const hiddenRef = useRef<HTMLButtonElement>(null);

  const handleConfirm = useCallback(() => {
    onConfirm();
    onClose();
  }, [onConfirm, onClose]);

  return (
    <AlertDialog isOpen={isOpen} isCentered size="lg" leastDestructiveRef={hiddenRef} onClose={onClose}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="xl" fontWeight="bold">
            Comprovante do Certificado
          </AlertDialogHeader>

          <AlertDialogBody>
            <Text fontSize="md">
              Envie agora o comprovante do seu certificado, aumentando a chance da sua transportadora ser selecionada pelas empresas <Button w={0} h={0} p={0} minW={0} ref={hiddenRef} />
            </Text>
          </AlertDialogBody>

          <AlertDialogFooter>
            <HStack w="100%">
              <Button isFullWidth autoFocus={false} ref={cancelRef} onClick={onClose} colorScheme="gray">
                Enviar mais tarde
              </Button>
              <Button onClick={handleConfirm} autoFocus={false} isFullWidth bg="gray.700" color="white" _hover={{ background: 'gray.800' }} _active={{ background: 'gray.900' }}>
                Enviar agora
              </Button>
            </HStack>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}

export { AlertUploadFile };
